export class MeasureTiss {
    id: number;
    code: string;
    name: string;
    initials: string;
}
